// material
import { CircularProgress, CircularProgressProps, Grid } from '@mui/material';

// props
const loadingVariants = ['default', 'page'] as const;
const sizeVariants = ['md', 'sm', 'xs'] as const;

export type LoadingVariant = (typeof loadingVariants)[number];
export type SizeVariant = (typeof sizeVariants)[number];

export interface LoadingProps {
	CircularProgressProps?: CircularProgressProps;
	size?: SizeVariant;
	variant?: LoadingVariant;
}

export const Loading = ({
	CircularProgressProps,
	variant = 'default',
	size = 'md',
}: LoadingProps) => {
	const sizes: Record<SizeVariant, number> = {
		md: 40,
		sm: 32,
		xs: 12,
	};
	const circularProgress = (
		<CircularProgress color="secondary" size={sizes[size]} {...CircularProgressProps} />
	);

	if (variant === 'default') {
		return circularProgress;
	}

	return (
		<Grid
			alignItems="center"
			container
			justifyContent="center"
			spacing={2}
			sx={(theme) => {
				if (variant === 'page') {
					return {
						height: `calc(100vh - ${theme.variables?.headerHeight})`,
					};
				}
				return {};
			}}>
			<Grid item>{circularProgress}</Grid>
		</Grid>
	);
};
